import { render } from "./ManageInstances.vue?vue&type=template&id=4842e85e&scoped=true"
import script from "./ManageInstances.vue?vue&type=script&lang=js"
export * from "./ManageInstances.vue?vue&type=script&lang=js"

import "./ManageInstances.vue?vue&type=style&index=0&id=4842e85e&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4842e85e"]])

export default __exports__